// WS-G public form entry helpers. Pure functions so main.tsx's pre-auth branch is unit-testable
// without invoking createRoot / MSAL. The public form lives at /f/{token}.

/** True when the path is the standalone public form (rendered BEFORE the MSAL auth gate). */
export function isPublicFormPath(pathname: string): boolean {
  return pathname === '/f' || pathname.startsWith('/f/');
}

/** Extracts the token from /f/{token} (empty string when absent). */
export function parseTokenFromPath(pathname: string): string {
  const match = pathname.match(/^\/f\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}
